import { z } from 'zod';

export const $CandidateVacancyActivity = z.object({
  id: z.number(),
  vacancyId: z.number(),
  activeFrom: z.string(),
  activeTo: z.string(),
});
